"use strict";
import ApiService from "@/core/services/api.service";

const baseURL = "Vehicles";

export default {
  getVehicleEditorInitData() {
    return new Promise(resolve => {
      ApiService.get(`${baseURL}/GetVehicleEditorInitData`).then(({ data }) => {
        resolve(data);
      });
    });
  },
  vehicleDelete(trackerId) {
    return new Promise(resolve => {
      ApiService.delete(`${baseURL}/VehicleDelete?trackerId=${trackerId}`).then(
        ({ data }) => {
          resolve(data);
        }
      );
    });
  },
  saveVehicle(payload) {
    return new Promise(resolve => {
      ApiService.post(`${baseURL}/SaveVehicle`, payload).result.then(
        ({ data }) => {
          resolve(data);
        }
      );
    });
  },
  vehicleRecInfo(trackerId) {
    return new Promise(resolve => {
      ApiService.get(
        `${baseURL}/VehicleRecInfo`,
        `?trackerID=${trackerId}`
      ).then(({ data }) => {
        resolve(data);
      });
    });
  },
  getProvinceAndTrackerData() {
    return new Promise(resolve => {
      ApiService.post(`${baseURL}/GetProvinceAndTrackerData`).result.then(
        ({ data }) => {
          resolve(data);
        }
      );
    });
  },
  importTrackersList(payload) {
    return new Promise(resolve => {
      ApiService.post(`${baseURL}/ImportTrackersList`, payload).result.then(
        ({ data }) => {
          resolve(data);
        }
      );
    });
  },
  vehicleTree(trackerId) {
    return new Promise(resolve => {
      ApiService.get(`${baseURL}/vehicleTree`, `?trackerID=${trackerId}`).then(
        ({ data }) => {
          resolve(data);
        }
      );
    });
  }
};
